export const LikeHeart = (like) => {
  return like ? (
    <svg
      width='17'
      height='14'
      viewBox='0 0 17 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.00286 0C2.30145 0 0 2.0076 0 4.61497C0 6.41369 0.847422 7.92804 1.97053 9.18248C3.08979 10.4326 4.5338 11.4819 5.83923 12.3602L8.0916 13.8755C8.33827 14.0415 8.66173 14.0415 8.9084 13.8755L11.1608 12.3602C12.4662 11.4819 13.9102 10.4326 15.0295 9.18248C16.1526 7.92804 17 6.41369 17 4.61497C17 2.0076 14.6985 0 11.9971 0C10.6046 0 9.3793 0.648961 8.5 1.48867C7.6207 0.648962 6.39537 0 5.00286 0Z'
        fill='#FF0000'
      />
    </svg>
  ) : (
    <svg
      width='17'
      height='14'
      viewBox='0 0 17 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0 4.61497C0 2.0076 2.30145 0 5.00286 0C6.39537 0 7.6207 0.648961 8.5 1.48867C9.3793 0.648961 10.6046 0 11.9971 0C14.6985 0 17 2.0076 17 4.61497C17 6.40106 16.2337 7.97174 15.1719 9.29942C14.1121 10.6248 12.7257 11.7497 11.3982 12.6637C10.8912 13.0128 10.3783 13.3349 9.90883 13.5725C9.46804 13.7956 8.96118 14 8.5 14C8.03882 14 7.53197 13.7956 7.09117 13.5725C6.62172 13.3349 6.10879 13.0128 5.60177 12.6637C4.27433 11.7497 2.88793 10.6248 1.82805 9.29942C0.766341 7.97174 0 6.40106 0 4.61497ZM5.00286 1.44828C2.98302 1.44828 1.45714 2.92465 1.45714 4.61497C1.45714 5.97007 2.03591 7.23172 2.96877 8.39828C3.90347 9.56713 5.16113 10.5984 6.43158 11.4732C6.91232 11.8042 7.36512 12.0859 7.75244 12.2819C8.1684 12.4925 8.40933 12.5517 8.5 12.5517C8.59067 12.5517 8.8316 12.4925 9.24756 12.2819C9.63488 12.0859 10.0877 11.8042 10.5684 11.4732C11.8389 10.5984 13.0965 9.56713 14.0312 8.39828C14.9641 7.23172 15.5429 5.97007 15.5429 4.61497C15.5429 2.92465 14.017 1.44828 11.9971 1.44828C10.8371 1.44828 9.75392 2.1371 9.07758 3.01137C8.93967 3.18964 8.72625 3.29412 8.5 3.29412C8.27375 3.29412 8.06033 3.18964 7.92242 3.01137C7.24608 2.1371 6.16289 1.44828 5.00286 1.44828Z'
        fill='white'
      />
    </svg>
  );
};
